import { useEffect, useState } from 'react';
import { MultiValue } from 'react-select';
import SelectField from '../../../../@shared/Fields/selectField';
import { Category, CategoryAddFormState } from '../CategoryForm/types';

export type CategoryChooserSuccessData = CategoryAddFormState & {
  categoryId?: number;
  readonly: boolean;
};

const CategorySelect = ({
  options = [],
  defaultValue,
  onChange,
}: {
  options: CategoryChooserSuccessData[] | Category[];
  defaultValue?: CategoryChooserSuccessData[];
  onChange?: (e: MultiValue<CategoryChooserSuccessData>) => void;
}) => {
  const [value, setValue] = useState<MultiValue<CategoryChooserSuccessData>>(
    defaultValue
      ?.filter((e) => e.categoryId)
      ?.map((e) => ({ ...e, label: e?.name, value: e?.categoryId })) || []
  );

  // Map options - handle both camelCase (frontend) and PascalCase (API) formats
  // Type assertion needed because options is a union type (CategoryChooserSuccessData[] | Category[])
  const optionsArray: Array<CategoryChooserSuccessData | Category> = Array.isArray(options)
    ? options
    : [];

  const op = optionsArray
    .filter((e: any) => {
      if (!e) return false;
      const categoryId = e.categoryId || e.CategoryId;
      return categoryId != null && categoryId !== undefined;
    })
    .map((e: any) => {
      // Normalize property names - support both camelCase and PascalCase
      const categoryId = e.categoryId || e.CategoryId;
      const name = e.name || e.Name;
      return {
        ...e,
        label: name || '',
        value: categoryId,
        categoryId,
        name: name || '',
      };
    });

  const valueString = JSON.stringify(value);
  useEffect(() => {
    if (onChange) onChange(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueString]);

  return (
    <SelectField<Category>
      name="categories"
      getOptionLabel={(e) => e.name}
      label="Categorias à selecionar"
      isMulti
      placeholder="Selecione"
      value={value}
      onChange={(e) => setValue(e as any)}
      options={op as any}
    />
  );
};

export default CategorySelect;
